import React, { useState, useEffect } from 'react';
import { isBefore, parseISO, intervalToDuration } from 'date-fns';
import { getApplication } from '../application';
import { decryptObject, encryptObject } from '../utils/encrypt';
import ModalSessionExpired from '../components/organisms/ModalSessionExpired';

const application = getApplication();

export const USER_KEY = application.key;
const { REACT_APP_SECRET } = process.env;

export const getLocalObj = (key) => {
  if (sessionStorage.getItem(key)) {
    return decryptObject(sessionStorage.getItem(key), REACT_APP_SECRET);
  }
};

// User OAuth
export const getUserData = () => getLocalObj(USER_KEY);

// Token
export const getTokenAccessToken = () => getLocalObj(USER_KEY).access_token;
export const getTokenCreated = () => getLocalObj(USER_KEY).created;
export const getTokenExpirationDate = () => getLocalObj(USER_KEY).expiration;
export const getTokenAuthenticated = () => getLocalObj(USER_KEY).authenticated;
export const isAccessTokenValid = () =>
  isBefore(new Date(), parseISO(getTokenExpirationDate()));

// Refresh token
export const getRefreshToken = () => getLocalObj(USER_KEY).refresh_token;
export const getRefreshTokenExpirationDate = () =>
  getLocalObj(USER_KEY).refreshTokenExpiresAt;
export const isRefreshTokenValid = () =>
  isBefore(new Date(), parseISO(getRefreshTokenExpirationDate()));

export const movcadUpt = () => {
  sessionStorage.setItem('@movcad-upt', true);
};

export const persistData = (data) => {
  const encryptData = encryptObject(data, REACT_APP_SECRET);
  sessionStorage.setItem(USER_KEY, encryptData);
};
export const excludeData = () => {
  sessionStorage.removeItem(USER_KEY);
};

export const setAuthorization = async (config) => {
  const token = getTokenAccessToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

export function TokenExpirationTimer() {
  const [timeLeft, setTimeLeft] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const duration = intervalToDuration({
        start: new Date(),
        end: new Date(getTokenExpirationDate()),
      });

      const { hours, minutes, seconds } = duration;

      const formattedTimeLeft = `${hours} horas, ${minutes} minutos e ${seconds} segundos`;
      setTimeLeft(formattedTimeLeft);

      if (hours === 0 && minutes === 0 && seconds === 0) {
        setShowModal(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div>Seu acesso expira em: {timeLeft}</div>
      <ModalSessionExpired
        isOpen={showModal}
        logOut={() => setShowModal(false)}
      />{' '}
      {/* Renderiza a modal */}
    </div>
  );
}
